$.fn.nl_last_word = function () {
    $(this).each(function(index, element) {
        var $this = $(element);
        if (!$this.hasClass("mod--last-word")) {
            var $word_array, $last_word, $first_part;

            $word_array = $this.html().split(/\s+/);
            $last_word = $word_array.pop();
            $first_part = $word_array.join(' ');

            $this.addClass("mod--last-word").html([$first_part, ' <b>', $last_word, '</b>'].join(''));
        }
    });
}